module.exports = __webpack_public_path__ + "img/toplupe.d8829a1.png";